<template>
  <generic-modal
    :value="value"
    title="Manage Page Types"
    confirm-text="Finish"
    hide-louis
    hide-buttons
    @modal-confirm="onCreateCancel"
    @modal-cancel="onCreateCancel"
  >
    <v-form ref="form">
      <page-type-resource
        v-if="item && item.id"
        :filters="{ site_group_id: item.id }"
        :attach-template="{ site_group_id: item.id, page_type_id: null }"
        resource-type="pageTypeSiteGroups"
        attach
      />
    </v-form>
  </generic-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GenericModal from '@/components/modals/generic-modal'
import PageTypeResource from '@/components/resources/page-type-resource'

export default {
  components: { GenericModal, PageTypeResource },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  methods: {
    onCreateCancel() {
      this.$emit('cancel')
    },
  },
}
</script>
